var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticClass:"chart-wrapper",attrs:{"width":"100%","height":"100%","type":"area","options":_vm.fullOptions.apex,"series":_vm.series}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }